// extracted by mini-css-extract-plugin
export default {"msgRow":"message_msgRow__j6zQ0","MiddleRow":"message_MiddleRow__atGR5"};